// extracted by mini-css-extract-plugin
module.exports = {"recipientName":"RecipientTableRow_recipientName__2HvdK"};